module.exports = "<app-limite-adicional-proposal\r\n  [propostaLCAdicionalID]=\"proposalID\"\r\n  [accountClientID]=\"accountClientID\"\r\n  [profileUser]=\"profileUser\"\r\n  [segmentoID]=\"segmentoID\"\r\n  class=\"proposalComponent\"\r\n>\r\n</app-limite-adicional-proposal>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/proposal-view-modal/LAproposal-view/la-proposal-view.component.html
// module id = ./src/app/account-client/component/account-client-details/proposal-view-modal/LAproposal-view/la-proposal-view.component.html
// module chunks = main